import { motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';

export const GridBackdrop = () => {
  const reducedMotion = useReducedMotion();

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_14%_6%,rgba(183,255,106,0.12),transparent_38%),radial-gradient(circle_at_88%_10%,rgba(88,247,182,0.1),transparent_36%),linear-gradient(180deg,#010307_0%,#050912_35%,#02050a_100%)]" />
      <div className="hud-grid absolute inset-0" />

      <motion.div
        className="absolute inset-y-0 left-[-35%] w-[32%] bg-[linear-gradient(90deg,transparent,rgba(183,255,106,0.1),transparent)]"
        animate={reducedMotion ? undefined : { x: ['-8%', '430%'], opacity: [0.1, 0.28, 0.12] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
      />

      <motion.div
        className="absolute inset-x-0 top-[-25%] h-[26%] bg-[linear-gradient(180deg,transparent,rgba(88,247,182,0.08),transparent)]"
        animate={reducedMotion ? undefined : { y: ['-10%', '440%'], opacity: [0.08, 0.2, 0.1] }}
        transition={{ duration: 16, repeat: Infinity, ease: 'linear' }}
      />

      <motion.div
        className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(27,131,95,0.3),transparent_44%)]"
        animate={reducedMotion ? undefined : { opacity: [0.35, 0.65, 0.35], scale: [1, 1.05, 1] }}
        transition={{ duration: 7.4, repeat: Infinity, ease: 'easeInOut' }}
      />

      <div className="hud-vignette absolute inset-0" />
    </div>
  );
};
